export default "__VITE_ASSET__bGw137ds__"